import { Avatar } from '@mui/material';
import { ExperienceFallback as Experience } from '../../../icons/experience-fallback';

type CompanyFallbackProps = {
    width: string,
    height: string,
}

export const CompanyFallback = ({ width, height }:CompanyFallbackProps):JSX.Element => {
  return (
    <Avatar
      alt="aleternate"
      sx={ {
        width,
        height,
        bgcolor: 'rgba(48, 37, 133, 1)',
      } }
      src=""
    >
      <Experience />
    </Avatar>
  );
};
